@if(view.newsletters && view.newsletters.content.length > 0) {
<section class="container mx-auto px-4 py-15">
    <h2 class="text-3xl font-bold text-center tracking-wide mb-10">Our Newsletters</h2>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        @for(newsletterItem of view.newsletters.content; track newsletterItem) {
        <!-- Blog Card Add ng loop here when articles are ready - Jacques-->
        <fuse-card class="flex flex-col bg-white rounded-lg shadow-lg overflow-hidden">
            <!-- @for(newsletterImage of view.newsletters.content; track index){
                        <img [src]="getFeaturedImage(index)" alt="Blog Image" class="w-full h-48 object-cover">
                    } -->
            <img [src]="newsletterItem.imageUrlRaw"
                alt="Blog Image" class="w-full h-48 object-cover">
                
            <div class="p-5">
                <div class="flex justify-between text-sm text-gray-500 mb-2">
                    @if(newsletterItem.createdOn) {
                        <span>📅 {{newsletterItem.createdOn | date: 'd MMM, y'}}</span>
                    }
                    @if(newsletterItem.author) {
                        <span>✍️ {{newsletterItem.author}}</span>
                    }
                </div>
                <h3 class="text-xl font-semibold text-gray-900 mb-2">{{newsletterItem.name}}</h3>
                <p class="text-gray-600 mb-4 truncate" [innerHTML]="newsletterItem.rawContentShort"></p>
                <div class="flex justify-end">
                    <button type="button"
                        class="rounded-lg uppercase font-semibold p-3 border-accent-500 bg-accent-500 text-primary-100 tracking-wide cursor-pointer sm:w-auto sm:flex-shrink-0 hover:text-primary-500 hover:bg-primary-100 transition ease-out duration-500">
                        View More →
                    </button>
                </div>
            </div>
        </fuse-card>
        }
    </div>

</section>
}